import React from 'react'
import { Link } from 'react-router-dom'
import { BiSolidPhoneCall } from "react-icons/bi";
import { IoLogoWhatsapp } from "react-icons/io";
import logo from "../assets/footerLogo.png"
import { FaLinkedin } from "react-icons/fa6";
import { FaSquareXTwitter } from "react-icons/fa6";
import { service } from '../Data/data';
import msme from "../assets/msme.png";
const Footer = ({setShow, setOpen}) => {
  const redirectToWhatsApp = () => {
    const phoneNumber = '7988066536';
    const whatsappLink = `https://api.whatsapp.com/send?phone=91${phoneNumber}`;
    window.location.href = whatsappLink;
  };
  const currentYear = new Date().getFullYear()
  
  return (

<>

<footer className=" bg-gray-100 text-black">
  <div className="max-w-screen-xl px-4 py-16 mx-auto sm:px-6 lg:px-8">
    <div className="grid grid-cols-1 gap-10 lg:grid-cols-3 max-sm:place-items-center max-md:place-items-center max-sm:text-center max-md:text-center">
      <div className="flex flex-col items-center justify-center space-y-6 text-center p-4">

  {/* Logo */}
  <Link to="/">
    <div className="flex items-center justify-center">
      <img
        src={logo}
        alt="logo"
        className="h-16 max-sm:h-20 w-auto"
      />
     
    </div>
  </Link>

  {/* Social Icons */}
  <div className="flex space-x-6 text-gray-600 items-center justify-center">
    <Link
      className="hover:opacity-75"
      to="https://www.facebook.com/share/16g26UZzEr/?mibextid=qi2Omg"
      target="_blank"
      rel="noreferrer"
    >
      <span className="sr-only">Facebook</span>
      
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
            </svg>
    </Link>

    <Link
      className="hover:opacity-75"
      to="https://www.instagram.com/socio_loom?igsh=MWNwOTlubGNld2tpeA=="
      target="_blank"
      rel="noreferrer"
    >
      <span className="sr-only">Instagram</span>
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
            </svg>
    </Link>

    <Link
      className="hover:opacity-75"
      to="https://www.linkedin.com/company/socioloom/"
      target="_blank"
      rel="noreferrer"
    >
      <FaLinkedin size={22} />
    </Link>

    <Link
      className="hover:opacity-75"
      to="https://x.com/Socio_Loom"
      target="_blank"
      rel="noreferrer"
    >
      <FaSquareXTwitter size={22} />
    </Link>
  </div>

  {/* MSME Logo */}
  <div className="flex items-center justify-center">
    <img src={msme} className="w-20 h-auto" alt="msme" />
  </div>

</div>

      <div className="grid grid-cols-1 gap-8 lg:col-span-2 sm:grid-cols-2 lg:grid-cols-3">
        <div>
          <p className="font-medium">
            Company
          </p>
          <nav className="flex flex-col mt-4 space-y-2 text-sm text-gray-500">
            <Link className="hover:opacity-75" to={"/about"}> About </Link>
            <Link className="hover:opacity-75" to={"/services"}> Services </Link>
            <Link className="hover:opacity-75" to={"/support"}> Support </Link>
            
            <Link className="hover:opacity-75" to={"/pricelist"}> Price </Link>
            <Link className="hover:opacity-75" to={"/portfolio"}> Portfolio </Link>
            <Link className="hover:opacity-75" to={"/blog"}> Blog </Link>
          </nav>
        </div>
        <div>
          <p className="font-medium">
            Services
          </p>
          <nav className="flex flex-col mt-4 space-y-2 text-sm text-gray-500">
            <Link className="hover:opacity-75" to={`/service/${service[0]?.slug}`} onClick={()=>setOpen(true)}> Web Development </Link>
            <Link className="hover:opacity-75" to={`/service/${service[1]?.slug}`} onClick={()=>setOpen(true)}> APP Development </Link>
            <Link className="hover:opacity-75" to={`/service/${service[2]?.slug}`} onClick={()=>setOpen(true)}> Digital Marketing </Link>
            <Link className="hover:opacity-75" to={`/service/${service[3]?.slug}`} onClick={()=>setOpen(true)}> Growth Strategy </Link>
            <Link className="hover:opacity-75" to={`/service/${service[4]?.slug}`} onClick={()=>setOpen(true)}> Market Research </Link>
            <Link className="hover:opacity-75" to={`/service/${service[5]?.slug}`} onClick={()=>setOpen(true)}> Business Strategy </Link>
            <Link className="hover:opacity-75" to={`/service/${service[6]?.slug}`} onClick={()=>setOpen(true)}> IT Solutions </Link>
          </nav>
        </div>
        <div>
          <p className="font-medium">
            Helpful Links
          </p>
          <nav className="flex flex-col mt-4 space-y-2 text-sm text-gray-500">
            <Link className="hover:opacity-75" to={"/contact"}> Contact Us</Link>
            <a className="hover:opacity-75" href> FAQs </a>
            <Link className="hover:opacity-75 "  to={"/contact"}> Raise a Query </Link>
          </nav>
        </div>
        {/* <div>
          <p className="font-medium">
            Legal
          </p>
          <nav className="flex flex-col mt-4 space-y-2 text-sm text-gray-500 ">
            <a className="hover:opacity-75" href> Privacy Policy </a>
            <a className="hover:opacity-75" href> Terms &amp; Conditions </a>
            <a className="hover:opacity-75" href> Returns Policy </a>
            <a className="hover:opacity-75" href> Accessibility </a>
          </nav>
        </div> */}
      </div>
    </div>
    <p className="mt-8 text-xs text-gray-800 max-sm:text-center max-md:text-center text-center">
      © {currentYear} SocioLoom
    </p>
  </div>
</footer>
 <div className=" max-sm:hidden w-full py-1 sticky bottom-0 bg-[#fff] text-[#000] z-50 flex items-center justify-evenly flex-wrap max-sm:gap-2 max-sm:h-[100%] " >
    <div className=" flex items-center justify-center gap-8">
     <span className=" flex items-center justify-center gap-2 ">

    
     </span>
                <span className="-mx-3 block rounded px-4 py-1 text-sm  font-semibold leading-7 bg-blue-600 text-center text-white cursor-pointer" onClick={()=>setShow(true)}>
                Request a Call-Back
                </span>
    </div>
    <div className='flex items-center justify-center gap-1 flex-wrap '>
    <p className='flex items-center justify-center gap-1 flex-wrap'>
    <span className=' text-sm'>For Support Call Us on- </span><span><BiSolidPhoneCall /></span>
     <span className=' text-sm ' >(+91-7988066536)</span> 
     <div className=' pl-5 flex item-center justify-center gap-1'><span className=' pt-1' ><IoLogoWhatsapp color='#2ECC71'/></span><Link target='_blank'>
     <span className=' text-sm hover:text-blue-700 cursor-pointer' onClick={redirectToWhatsApp}>(+91-7988066536)</span>
     </Link></div>
     
     </p>
    </div>
    </div>
</>
  )
}

export default Footer
